import { message } from "antd";

const shouldLogEventsApi = process.env.NODE_ENV === "development";

export const logEventDebug = (...args) => {
  if (shouldLogEventsApi) {
    console.log(...args);
  }
};

export const showEventApiError = (error, fallbackMessage, debugMessage) => {
  logEventDebug(debugMessage, error);
  message.error(fallbackMessage);
};
